<template>
  <div>
    <div class="td-training">
      <div class="training-day">
        <div class="header-date" :class="[{ 'header-date-today': isTodayDate(this.day.format) }]">
          {{ getDay }}
        </div>
        <!-- день без тренировок, но с возможностью добавить новую -->
        <div v-if="!day.trainings && day.isAfterNow && hasRightsToEdit" class="b-training b-training-empty">
          <base-spinner v-if="saving && day.saving"> </base-spinner>
          <svg-icon v-else @click:icon="addTraining(day)" class="svg-icon-middle" :name="'plus'"></svg-icon>
        </div>
        <!-- дни с тренировками -->
        <div v-else-if="day.trainings" class="b-training b-training-scroll">
          <div
            v-for="training in day.trainings"
            :key="training.id"
            :class="[
              `b-training-${getStatusColor(training)}`,
              { 'b-training-single': isSingle },
              { 'b-training-many': !isSingle }
            ]"
          >
            <!-- если в день одна тренировка -->
            <TrainingDayDetails
              v-if="isSingle"
              :training="training"
              :hasRightsToEdit="hasRightsToEdit"
              @remove="removeTraining"
            />

            <!-- если несколько -->
            <TrainingDayDetailsMany v-else :training="training" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { trainingItem } from '@/mixins/training-item.js'
import { nameMonths } from '@/mixins/name-months.js'
import SvgIcon from '@/components/SvgIcon.vue'
import BaseSpinner from '@/base/BaseSpinner.vue'
import TrainingDayDetails from '@/components/Training/TrainingDayDetails.vue'
import TrainingDayDetailsMany from '@/components/Training/TrainingDayDetailsMany.vue'

export default {
  name: 'TrainingTableDay',
  components: {
    SvgIcon,
    BaseSpinner,
    TrainingDayDetails,
    TrainingDayDetailsMany
  },
  mixins: [trainingItem, nameMonths],
  props: {
    day: {
      type: Object,
      required: true
    },
    trainings: {
      type: Array,
      required: false
    },
    hasRightsToEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    saving: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      position: 0,
      cellHeight: 160
    }
  },
  computed: {
    isSingle() {
      return this.trainings.length === 1
    },
    getDay() {
      const date = this.moment(this.day.date)
      const day = date.date()
      if (day === 1 || this.day.isFirst) {
        let month = this.getGenitiveMonths(date)
        return `${day} ${month}`
      }
      return day
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.trainingCell) {
        this.cellHeight = this.$refs.trainingCell.offsetHeight
      }
    })
  },
  methods: {
    removeTraining(training) {
      this.$emit('remove', training)
    },
    addTraining(day) {
      this.$emit('addTraining', day)
    }
  }
}
</script>
